export default "__VITE_ASSET__1d7e9626__"